module.exports = __webpack_public_path__ + "static/media/heldane-text-web-regular.239cc9b3.eot";